module.exports = __webpack_public_path__ + "static/Chainguardians-f33ad7808714e0f070c5fa505cedc721.png";